<template>
    <div>
        <f7-list v-if="myBookmarks.length === 0 && isLoaded">
            <f7-list-item :title="'You don\'t have any bookmarks yet.'" />

        </f7-list>
        <f7-list
            v-else
            media-list
        >
            <sequential-entrance from-bottom>
                <template v-for="(bookmark, index) in myBookmarks">
                    <unit-card
                        v-show="index < maxItems"
                        :unit="unitsIndex[bookmark.unit.id] || bookmark.unit"
                        :key="`bookmark-${index}`"
                        :home="true"
                        :in-card="true"
                        :index="index"
                        :pack="myBookmarks"
                    />
                </template>
            </sequential-entrance>
        </f7-list>
        <p
            v-if="moreBookmarks"
            class="moreLinks"
        >
            <a
                href="/bookmarks"
                class="moreLink"
            >View all &mdash;</a>
        </p>
    </div>
</template>

<script>
import UnitCard from '../../components/unitCard.vue';

export default {
    store: ['api', 'myBookmarks', 'unitsIndex', 'topicsIndex', 'coursesIndex'],
    components: {
        UnitCard
    },
    data () {
        return {
            isLoaded: false,
            bookmarksPreview: [],
            moreBookmarks: false
        };
    },
    computed: {
        isPgap: function () {
            return pgap;
        },
        maxItems: function () {
            return window.innerHeight > 1000 ? 4 : 2;
        }
    },
    created: function () {
        this.getMyBookmarks();
    },
    mounted: function () { },
    methods: {
        getMyBookmarks: function () {
            this.moreBookmarks = this.myBookmarks.length > this.maxItems;
            this.$http.get(`${this.api}/bookmarks?limit=${this.maxItems + 1}`).then(
                response => {
                    this.myBookmarks = response.body;
                    // dirty reactivity hack
                    for (let i = 0; i < this.myBookmarks.length; i++) {
                        const b = this.myBookmarks[i];
                        b.unit.bookmarked = true;
                        if (this.unitsIndex[b.unit.id]) {
                            Vue.set(this.unitsIndex[b.unit.id], 'bookmarked', true);
                        }
                    }
                    this.moreBookmarks = this.myBookmarks.length > this.maxItems;
                    this.isLoaded = true;
                },
                () => {
                    console.error('Could not fetch bookmarks');
                }
            );
        }
    }
};
</script>
<style lang="less" scoped>
@import '../../css/colors.less';
.moreLinks {
    padding: 0;
    text-align: right;
    margin: -20px 16px 0;
    text-transform: uppercase;
    font-family: AndesMedium;
    letter-spacing: 1px;
    font-weight: bold;
    font-size: 12px;
    color: #ff6f61;
}
.moreLink {
    font-size: 15px;
    color: @coral;
    font-family: AndesMedium;
    text-transform: uppercase;
    line-height: 44px;
    float: right;
    z-index: 100;
    position: relative;
}
</style>
